<div class="container">
    <h2>Thank you</h2>
    <p>Your KYC is under process. Please use our app to check the status.</p>
  </div>